'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Form } from '@/ui/form'
import { useForm } from '@/ui/form/Form.client'
import { Select } from '@/ui/form/inputs/select/Select.client'
import { useMemo } from 'react'
import { PAGINATION_SELECT_CLASSNAME } from './pagination.styles'

type PaginationPageSelectProps = {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function PaginationPageSelect({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationPageSelectProps) {
  const { t } = useTranslation(['pagination'])
  const pageLabel = t('pagination:pageDetails', { currentPage, totalPages })
  const form = useForm({
    values: { page: String(currentPage) },
  })

  const items = useMemo(
    () =>
      Array.from({ length: totalPages }, (_, index) => {
        const page = index + 1

        return {
          id: String(page),
          label: String(page),
        }
      }),
    [totalPages],
  )

  return (
    <Form form={form} onSubmitAction={() => undefined} className={PAGINATION_SELECT_CLASSNAME}>
      <Select
        name="page"
        label=""
        items={items}
        selectionMode="single"
        withTags={false}
        placeholder={pageLabel}
        aria-label={pageLabel}
        onValueChange={(value) => {
          if (typeof value !== 'string') return

          const page = Number(value)
          if (!Number.isInteger(page) || page === currentPage) return

          onPageChange(page)
        }}
        maxHeight={180}
        className={PAGINATION_SELECT_CLASSNAME}
      />
    </Form>
  )
}
